var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.65686 14.9804C7.86129 15.1662 8.17723 15.1477 8.36307 14.9432C8.54891 14.7388 8.53033 14.4229 8.3259 14.237L1.13375 7.73249C0.947905 7.56523 0.947905 7.32364 1.13375 7.15638L8.3259 0.874859C8.53033 0.689015 8.54891 0.373081 8.38165 0.168653C8.19581 -0.035775 7.87988 -0.0543592 7.67545 0.1129L0.483296 6.413C-0.148573 6.97053 -0.167157 7.89975 0.464712 8.47587L7.65686 14.9804Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/BackIcon.a7f96bedef5530e7da85b36e925b1016.svg";
export { ForwardRef as ReactComponent };